import Button from "components/ui/Button/Button";
import TermSearch from "features/view/components/TermSearch/TermSearch";
import Facets from "features/view/components/Facets/Facets";
import { useView } from "features/view/context/ViewContext";
import { ReactComponent as IconClose } from "assets/images/icons/close.svg";
import "features/view/components/Filters/Filters.scss";
import LocationSearch from "features/view/components/LocationSearch/LocationSearch";
import Tooltip from "components/ui/Tooltip/Tooltip";

function Filters({ hasLocation = false }) {
  const { view, clearFilters, hasFilters, showMobileFilters, setShowMobileFilters } = useView();
  return (
    <div className={ `filters ${ showMobileFilters ? 'filters--open' : '' }` }>
      <div className="filters__close" onClick={ () => setShowMobileFilters(false) }>
        <IconClose/>
      </div>
      <h3 className="filters__title">
        Zoekfilters
        <Tooltip message={ 'Gevonden resultaten kunt u hier verder filteren.' }/>
      </h3>

      {
        view && view.pager &&
        <div className="filters__results">{ view.pager.total_items } resultaten gevonden</div>
      }
      {
        view && (hasFilters()) &&
        <div className="filters__reset">
          <Button onClick={ () => clearFilters() } variant="light">
            <IconClose/>
            Verwijder filters
          </Button>
        </div>
      }
      <TermSearch/>
      {
        hasLocation &&
        <LocationSearch/>
      }
      <Facets/>
      { view && view.pager &&
      <Button onClick={ () => setShowMobileFilters(false) }
              className="filters__show-results button--secondary">Toon { view.pager.total_items } resultaten</Button>
      }
    </div>
  );
}

export default Filters;
